import { DocumentBuyerModel } from '@skylab-shared/dataModel';

export function getBuyerSummary(buyer: DocumentBuyerModel): string {
    const parts = [buyer.name];

    if (buyer.address) {
        parts.push(buyer.address.line1);
        parts.push(((buyer.address.zipCode || '') + ' ' + (buyer.address.city || '')).trim());
    }

    return parts
        .filter(e => !!e)
        .join(', ');
}
